// Localização: frontend/src/hooks/useContasPagar.js
// Hook para gerenciamento de Contas a Pagar

import { useState, useCallback } from 'react';
import { contaPagarApi } from '../api/financeiroApi';
import { useAuth } from '../context/AuthContext';

export const useContasPagar = () => {
    const { isAuthenticated } = useAuth();
    
    const [contasPagar, setContasPagar] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 20,
        total: 0,
        totalPages: 0
    });

    // -------------------------------------------------------------------
    // FUNÇÃO DE BUSCA (READ)
    // -------------------------------------------------------------------

    const fetchContasPagar = useCallback(async (params = {}) => {
        if (!isAuthenticated) return;
        setIsLoading(true);
        setError(null);
        try {
            const response = await contaPagarApi.getAll(params);
            const data = response.data;
            setContasPagar(data.data || []);
            setPagination(data.pagination || {
                page: 1,
                limit: 20,
                total: 0,
                totalPages: 0
            });
        } catch (err) {
            console.error("Erro ao buscar contas a pagar:", err);
            setError(err.response?.data?.message || "Falha ao carregar contas a pagar.");
            setContasPagar([]);
        } finally {
            setIsLoading(false);
        }
    }, [isAuthenticated]);

    // -------------------------------------------------------------------
    // FUNÇÕES DE MUTAÇÃO (CREATE, UPDATE, DELETE)
    // -------------------------------------------------------------------

    const createContaPagar = async (data) => {
        try {
            const response = await contaPagarApi.create(data);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.message || 'Falha ao cadastrar conta a pagar.');
        }
    };
    
    const updateContaPagar = async (id, data) => {
        try {
            const response = await contaPagarApi.update(id, data);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.message || 'Falha ao atualizar conta a pagar.');
        }
    };
    
    const deleteContaPagar = async (id) => {
        try {
            await contaPagarApi.delete(id);
        } catch (err) {
            throw new Error(err.response?.data?.message || 'Falha ao cancelar conta a pagar.');
        }
    };

    // -------------------------------------------------------------------
    // FUNÇÕES DE PAGAMENTO
    // -------------------------------------------------------------------

    const registrarPagamentoTotal = async (id, data) => {
        try {
            const response = await contaPagarApi.pagar(id, data);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.message || 'Falha ao registrar pagamento.');
        }
    };

    const registrarPagamentoParcial = async (id, data) => {
        try {
            const response = await contaPagarApi.pagarParcial(id, data);
            return response.data;
        } catch (err) {
            throw new Error(err.response?.data?.message || 'Falha ao registrar pagamento parcial.');
        }
    };

    // -------------------------------------------------------------------
    // RETORNO PÚBLICO
    // -------------------------------------------------------------------

    return {
        contasPagar,
        isLoading,
        error,
        pagination,
        
        // Funções CRUD
        createContaPagar,
        updateContaPagar,
        deleteContaPagar,
        
        // Funções de pagamento
        registrarPagamentoTotal,
        registrarPagamentoParcial,
        
        // Função de busca
        fetchContasPagar
    };
};

